export default {
      id: "help__geoitems1_icon-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#help__geoitems1_icon",
      toString: function () {
        return this.url;
      }
    }